// import React, { useEffect, useState } from 'react';
// import {
//   Button, Modal, Form, Input, InputNumber,
//   Space, Tag, Popconfirm, message, Typography, Card, Alert, Divider, Select,
// } from 'antd';
// import {
//   PlusOutlined, EditOutlined, DeleteOutlined,
//   PictureOutlined, StarOutlined,
// } from '@ant-design/icons';
// import { REST_BASE, API_KEY } from '../firebase/config';
// import { useThemeColors } from '../hooks/Usethemecolors';
// import ColorSelect from '../components/ColorSelect';

// const { Title, Text } = Typography;
// const { TextArea } = Input;

// // ── REST helpers ──────────────────────────────────────────────────────────────

// function toValue(v) {
//   if (v === null || v === undefined) return { nullValue: null };
//   if (typeof v === 'boolean')        return { booleanValue: v };
//   if (typeof v === 'number')         return Number.isInteger(v) ? { integerValue: String(v) } : { doubleValue: v };
//   if (typeof v === 'string')         return { stringValue: v };
//   if (Array.isArray(v))              return { arrayValue: { values: v.map(toValue) } };
//   if (typeof v === 'object')         return { mapValue: { fields: toFields(v) } };
//   return { stringValue: String(v) };
// }
// function toFields(obj) {
//   const f = {};
//   for (const [k, v] of Object.entries(obj)) f[k] = toValue(v);
//   return f;
// }
// function fromValue(v) {
//   if (!v) return null;
//   if ('stringValue'  in v) return v.stringValue;
//   if ('integerValue' in v) return Number(v.integerValue);
//   if ('doubleValue'  in v) return Number(v.doubleValue);
//   if ('booleanValue' in v) return v.booleanValue;
//   if ('nullValue'    in v) return null;
//   if ('arrayValue'   in v) return (v.arrayValue.values || []).map(fromValue);
//   if ('mapValue'     in v) {
//     const o = {};
//     for (const [k, val] of Object.entries(v.mapValue.fields || {})) o[k] = fromValue(val);
//     return o;
//   }
//   return null;
// }
// function fromFields(fields) {
//   const o = {};
//   for (const [k, v] of Object.entries(fields)) o[k] = fromValue(v);
//   return o;
// }

// async function restGet(col) {
//   const res = await fetch(`${REST_BASE}/${col}?key=${API_KEY}&orderBy=order`);
//   if (res.status === 404) return [];
//   if (!res.ok) throw new Error(`GET ${col} failed: ${res.status}`);
//   const json = await res.json();
//   if (!json.documents) return [];
//   return json.documents.map(d => ({ id: d.name.split('/').pop(), ...fromFields(d.fields || {}) }));
// }
// async function restSet(col, id, data) {
//   const res = await fetch(`${REST_BASE}/${col}/${id}?key=${API_KEY}`, {
//     method: 'PATCH', headers: { 'Content-Type': 'application/json' },
//     body: JSON.stringify({ fields: toFields(data) }),
//   });
//   if (!res.ok) { const e = await res.json().catch(() => {}); throw new Error(e?.error?.message || `Save failed: ${res.status}`); }
// }
// async function restPost(col, data) {
//   const res = await fetch(`${REST_BASE}/${col}?key=${API_KEY}`, {
//     method: 'POST', headers: { 'Content-Type': 'application/json' },
//     body: JSON.stringify({ fields: toFields(data) }),
//   });
//   if (!res.ok) { const e = await res.json().catch(() => {}); throw new Error(e?.error?.message || `Add failed: ${res.status}`); }
//   return (await res.json()).name.split('/').pop();
// }
// async function restDelete(col, id) {
//   const res = await fetch(`${REST_BASE}/${col}/${id}?key=${API_KEY}`, { method: 'DELETE' });
//   if (!res.ok && res.status !== 404) throw new Error(`Delete failed: ${res.status}`);
// }

// // ── Seed data ─────────────────────────────────────────────────────────────────

// const SEED_CERTS = [
//   { title:'Beginner Python',         issuer:'SoloLearn', year:'2023', color:'#c8f04a', src:'./Beg_python-1.png',         tags:['Python','Programming','Basics'],            desc:'Covers Python fundamentals including variables, loops, functions, and problem-solving concepts.', order:1 },
//   { title:'Data Structure in Python',issuer:'SoloLearn', year:'2023', color:'#00e5ff', src:'./data_structure-1.png',      tags:['Python','Data Structures','Algorithms'],    desc:'Demonstrates understanding of Python data structures such as lists, stacks, queues, dictionaries, and algorithms.', order:2 },
//   { title:'Data Science for Python', issuer:'SoloLearn', year:'2023', color:'#a78bfa', src:'./Dtsc-1.png',                tags:['Python','Data Science','Analytics'],        desc:'Focuses on Python for data analysis, visualization, and introductory data science concepts.', order:3 },
//   { title:'Intermediate Python',     issuer:'SoloLearn', year:'2023', color:'#c8f04a', src:'./intermediate_python-1.png', tags:['Python','Advanced Concepts','Programming'], desc:'Covers intermediate Python concepts including OOP, exception handling, modules, and file management.', order:4 },
//   { title:'JavaScript',              issuer:'SoloLearn', year:'2023', color:'#00e5ff', src:'./js-1.png',                  tags:['JavaScript','Frontend','Web Development'],  desc:'Builds JavaScript fundamentals including DOM manipulation, ES6 features, functions, and async concepts.', order:5 },
//   { title:'Prompt Engineering',      issuer:'SoloLearn', year:'2026', color:'#ff6b6b', src:'./PE-1.png',                  tags:['AI','Prompt Engineering','LLMs'],            desc:'Covers prompt optimization, AI communication, and effective prompting techniques for large language models.', order:6 },
// ];

// const SEED_REVIEWS = [
//   {
//     name: 'Bala Vishnu R',
//     role: 'CEO,Techno Tackle',
//     text: 'This is one of the coolest ways to send resumes. I really like the concept and how smoothly it works. It offers a creative and modern approach to job applications, making the process faster and more efficient. The idea stands out from traditional resume submissions and shows strong innovation.',
//     tag: 'Resume Sender',
//     year: '2026',
//     order: 1,
//   },
//   {
//     name: 'Vignesh Waran',
//     role: 'Junior HR, Evolv Clothing Company Pvt Ltd',
//     text: 'A clean and professional portfolio that showcases projects effectively and makes it easy to understand the candidate’s skills and experience.',
//     tag: 'Portfolio Website',
//     year: '2026',
//     order: 2,
//   },
// ];
// const TAG_OPTIONS = [
//   'UI/UX','Frontend Dev','Full Stack','Product Design','React / GSAP',
//   'Backend','Mobile','DevOps','Branding','Consulting',
// ];

// // ── Main component ────────────────────────────────────────────────────────────

// export default function CertificatesPage() {
//   const [data,          setData]          = useState([]);
//   const [loading,       setLoading]       = useState(false);
//   const [modalOpen,     setModalOpen]     = useState(false);
//   const [editing,       setEditing]       = useState(null);
//   const [seeding,       setSeeding]       = useState(false);
//   const [tags,          setTags]          = useState([]);
//   const [tagInput,      setTagInput]      = useState('');

//   // ── Reviews state ─────────────────────────────────────────────────────────
//   const [reviews,        setReviews]        = useState([]);
//   const [reviewsLoading, setReviewsLoading] = useState(false);
//   const [reviewModal,    setReviewModal]    = useState(false);
//   const [editingReview,  setEditingReview]  = useState(null);
//   const [seedingReviews, setSeedingReviews] = useState(false);

//   // ── Section settings (outro images) ───────────────────────────────────────
//   const [settingsSaving, setSettingsSaving] = useState(false);
//   const [settingsLoaded, setSettingsLoaded] = useState(false);

//   // ── Controlled color state — kept outside form ────────────────────────────
//   const [selectedColor, setSelectedColor] = useState('#c8f04a');

//   const [form]         = Form.useForm();
//   const [settingsForm] = Form.useForm();
//   const [reviewForm]   = Form.useForm();

//   const { themeColors, loading: themeLoading, error: themeError } = useThemeColors();

//   // ── Load certificates ─────────────────────────────────────────────────────
//   const load = async () => {
//     setLoading(true);
//     try { setData(await restGet('certificates')); }
//     catch (e) { message.error('Load failed: ' + e.message); }
//     finally { setLoading(false); }
//   };

//   // ── Load reviews ──────────────────────────────────────────────────────────
//   const loadReviews = async () => {
//     setReviewsLoading(true);
//     try { setReviews(await restGet('reviews')); }
//     catch (e) { message.error('Reviews load failed: ' + e.message); }
//     finally { setReviewsLoading(false); }
//   };

//   // ── Load section settings ─────────────────────────────────────────────────
//   const loadSettings = async () => {
//     try {
//       const res = await fetch(`${REST_BASE}/settings/certificates?key=${API_KEY}`);
//       if (res.ok) {
//         const json = await res.json();
//         const s = fromFields(json.fields || {});
//         settingsForm.setFieldsValue({
//           maskImage:   s.maskImage   || './mask.png',
//           revealImage: s.revealImage || './desktop.png',
//         });
//       } else {
//         settingsForm.setFieldsValue({ maskImage: './mask.png', revealImage: './desktop.png' });
//       }
//     } catch {
//       settingsForm.setFieldsValue({ maskImage: './mask.png', revealImage: './desktop.png' });
//     } finally {
//       setSettingsLoaded(true);
//     }
//   };

//   // ── Save section settings ─────────────────────────────────────────────────
//   const saveSettings = async () => {
//     try {
//       setSettingsSaving(true);
//       const vals = await settingsForm.validateFields();
//       await restSet('settings', 'certificates', vals);
//       message.success('Outro images saved!');
//     } catch (e) {
//       if (!e?.errorFields) message.error('Save failed: ' + (e.message || ''));
//     } finally {
//       setSettingsSaving(false);
//     }
//   };

//   useEffect(() => {
//     load();
//     loadReviews();
//     loadSettings();
//   }, []);

//   // ── Open cert modal ───────────────────────────────────────────────────────
//   const openAdd = () => {
//     setEditing(null);
//     form.resetFields();
//     const defaultColor = themeColors.find(c => c.varName === '--acid')?.hex || '#c8f04a';
//     setSelectedColor(defaultColor);
//     form.setFieldsValue({ year: String(new Date().getFullYear()), order: data.length + 1 });
//     setTags([]);
//     setTagInput('');
//     setModalOpen(true);
//   };

//   const openEdit = (record) => {
//     setEditing(record);
//     setSelectedColor(record.color || '#c8f04a');
//     form.setFieldsValue({
//       title:  record.title,
//       issuer: record.issuer,
//       year:   record.year,
//       src:    record.src,
//       desc:   record.desc,
//       order:  record.order,
//     });
//     setTags(record.tags || []);
//     setTagInput('');
//     setModalOpen(true);
//   };

//   // ── Save certificate ──────────────────────────────────────────────────────
//   const handleSave = async () => {
//     try {
//       const vals = await form.validateFields();
//       const payload = { ...vals, color: selectedColor, tags };
//       if (editing) {
//         await restSet('certificates', editing.id, payload);
//         message.success('Certificate updated!');
//       } else {
//         await restPost('certificates', payload);
//         message.success('Certificate added!');
//       }
//       setModalOpen(false);
//       load();
//     } catch (e) {
//       if (e?.errorFields) return;
//       message.error('Save failed: ' + (e.message || ''));
//     }
//   };

//   // ── Delete certificate ────────────────────────────────────────────────────
//   const handleDelete = async (id) => {
//     try { await restDelete('certificates', id); message.success('Deleted'); load(); }
//     catch (e) { message.error('Delete failed: ' + e.message); }
//   };

//   // ── Seed certificates ─────────────────────────────────────────────────────
//   const handleSeed = async () => {
//     setSeeding(true);
//     try {
//       const acid   = themeColors.find(c => c.varName === '--acid')?.hex   || '#c8f04a';
//       const cyan   = themeColors.find(c => c.varName === '--cyan')?.hex   || '#00e5ff';
//       const purple = themeColors.find(c => c.varName === '--purple')?.hex || '#a78bfa';
//       const red    = themeColors.find(c => c.varName === '--red')?.hex    || '#ff6b6b';
//       const themed = SEED_CERTS.map((cert, i) => ({
//         ...cert,
//         color: [acid, cyan, purple, acid, cyan, red][i] || cert.color,
//       }));
//       for (const cert of themed) await restPost('certificates', cert);
//       message.success('Seeded all certificates!');
//       load();
//     } catch (e) {
//       message.error('Seed failed: ' + e.message);
//     } finally {
//       setSeeding(false);
//     }
//   };

//   // ── Open review modal ─────────────────────────────────────────────────────
//   const openAddReview = () => {
//     setEditingReview(null);
//     reviewForm.resetFields();
//     reviewForm.setFieldsValue({ year: String(new Date().getFullYear()), order: reviews.length + 1 });
//     setReviewModal(true);
//   };

//   const openEditReview = (r) => {
//     setEditingReview(r);
//     reviewForm.setFieldsValue({
//       name:  r.name,
//       role:  r.role,
//       text:  r.text,
//       tag:   r.tag,
//       year:  r.year,
//       order: r.order,
//     });
//     setReviewModal(true);
//   };

//   // ── Save review ───────────────────────────────────────────────────────────
//   const handleSaveReview = async () => {
//     try {
//       const vals = await reviewForm.validateFields();
//       if (editingReview) {
//         await restSet('reviews', editingReview.id, vals);
//         message.success('Review updated!');
//       } else {
//         await restPost('reviews', vals);
//         message.success('Review added!');
//       }
//       setReviewModal(false);
//       loadReviews();
//     } catch (e) {
//       if (e?.errorFields) return;
//       message.error('Save failed: ' + (e.message || ''));
//     }
//   };

//   // ── Delete review ─────────────────────────────────────────────────────────
//   const handleDeleteReview = async (id) => {
//     try { await restDelete('reviews', id); message.success('Deleted'); loadReviews(); }
//     catch (e) { message.error('Delete failed: ' + e.message); }
//   };

//   // ── Seed reviews ──────────────────────────────────────────────────────────
//   const handleSeedReviews = async () => {
//     setSeedingReviews(true);
//     try {
//       for (const r of SEED_REVIEWS) await restPost('reviews', r);
//       message.success('Seeded all reviews!');
//       loadReviews();
//     } catch (e) {
//       message.error('Seed failed: ' + e.message);
//     } finally {
//       setSeedingReviews(false);
//     }
//   };

//   // ── Tags ──────────────────────────────────────────────────────────────────
//   const addTag = () => {
//     const t = tagInput.trim();
//     if (t && !tags.includes(t)) setTags([...tags, t]);
//     setTagInput('');
//   };

//   return (
//     <>
//       {/* ── Page header ──────────────────────────────────────────────────── */}
//       <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//         <Title level={4} style={{ margin: 0 }}>Certificates</Title>
//         <Space>
//           {data.length === 0 && (
//             <Button loading={seeding} onClick={handleSeed}>Seed Default Certs</Button>
//           )}
//           <Button type="primary" icon={<PlusOutlined />} onClick={openAdd}>Add Certificate</Button>
//         </Space>
//       </div>

//       {themeError && (
//         <Alert message={themeError} type="warning" showIcon closable style={{ marginBottom: 12 }} />
//       )}

//       {/* ── Section Settings Card ─────────────────────────────────────────── */}
//       <Card
//         title={
//           <Space>
//             <PictureOutlined style={{ color: '#a78bfa' }} />
//             <Text strong>Outro Section Images</Text>
//           </Space>
//         }
//         style={{ marginBottom: 20, borderLeft: '3px solid #a78bfa' }}
//         extra={
//           <Button type="primary" loading={settingsSaving} onClick={saveSettings} disabled={!settingsLoaded}>
//             Save Images
//           </Button>
//         }
//         size="small"
//       >
//         <Alert
//           message={
//             <span>
//               These two images power the interactive <b>"hover to reveal"</b> outro shown after all certificates.
//               Use a relative path (<code>./mask.png</code>) for public folder images, or a full <code>https://</code> URL.
//             </span>
//           }
//           type="info" showIcon style={{ marginBottom: 14 }}
//         />
//         <Form form={settingsForm} layout="vertical" initialValues={{ maskImage: './mask.png', revealImage: './desktop.png' }}>
//           <Space style={{ width: '100%' }} size={12} direction="vertical">
//             <Form.Item
//               name="maskImage"
//               label="Base Image (always visible, desaturated background)"
//               rules={[{ required: true, message: 'Base image URL is required' }]}
//               style={{ marginBottom: 0 }}
//               extra="Shown at all times as the greyed-out background portrait."
//             >
//               <Input placeholder="./mask.png  or  https://cdn.example.com/mask.jpg" />
//             </Form.Item>
//             <Form.Item
//               name="revealImage"
//               label="Reveal Image (shown inside the hover silhouette)"
//               rules={[{ required: true, message: 'Reveal image URL is required' }]}
//               style={{ marginBottom: 0 }}
//               extra="Revealed in full colour only where the user hovers over the silhouette."
//             >
//               <Input placeholder="./desktop.png  or  https://cdn.example.com/reveal.jpg" />
//             </Form.Item>
//           </Space>
//         </Form>
//       </Card>

//       {/* ── Cert image tip ───────────────────────────────────────────────── */}
//       <Alert
//         message='Tip: "src" is the certificate image. Use a relative path (./cert.png) for public folder images, or a full HTTPS URL.'
//         type="info" showIcon style={{ marginBottom: 16 }}
//       />

//       {/* ── Certificate grid ─────────────────────────────────────────────── */}
//       {loading ? <div>Loading…</div> : (
//         <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))', gap: 16 }}>
//           {data.map(cert => (
//             <Card
//               key={cert.id}
//               style={{ borderLeft: `3px solid ${cert.color}`, background: '#fff' }}
//               title={
//                 <Space>
//                   <span style={{ width: 10, height: 10, borderRadius: '50%', background: cert.color, display: 'inline-block' }} />
//                   <Text strong style={{ color: '#000' }}>{cert.title}</Text>
//                 </Space>
//               }
//               extra={
//                 <Space>
//                   <Button size="small" icon={<EditOutlined />} onClick={() => openEdit(cert)} />
//                   <Popconfirm title="Delete this certificate?" onConfirm={() => handleDelete(cert.id)}>
//                     <Button size="small" danger icon={<DeleteOutlined />} />
//                   </Popconfirm>
//                 </Space>
//               }
//               size="small"
//             >
//               <Space direction="vertical" size={4} style={{ width: '100%' }}>
//                 <Text style={{ color: '#888', fontSize: 12 }}><b>Issuer:</b> {cert.issuer}</Text>
//                 <Text style={{ color: '#888', fontSize: 12 }}><b>Year:</b> {cert.year}</Text>
//                 <Text style={{ color: '#888', fontSize: 12 }}><b>Order:</b> {cert.order}</Text>
//                 <Text style={{ color: '#666', fontSize: 11 }}>{cert.desc}</Text>
//                 <div style={{ marginTop: 4 }}>
//                   {(cert.tags || []).map((t, i) => (
//                     <Tag key={i} color={cert.color} style={{ color: '#000', fontSize: 10, marginBottom: 4 }}>{t}</Tag>
//                   ))}
//                 </div>
//               </Space>
//             </Card>
//           ))}
//         </div>
//       )}

//       {/* ════════════════════════════════════════════════════════════════════ */}
//       {/*  REVIEWS SECTION                                                    */}
//       {/* ════════════════════════════════════════════════════════════════════ */}
//       <Divider style={{ margin: '32px 0 24px' }} />

//       <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//         <Space align="center">
//           <StarOutlined style={{ color: '#c8f04a', fontSize: 18 }} />
//           <Title level={4} style={{ margin: 0 }}>Reviews</Title>
//           <Text type="secondary" style={{ fontSize: 12 }}>shown in the outro card-stack after certificates</Text>
//         </Space>
//         <Space>
//           {reviews.length === 0 && (
//             <Button loading={seedingReviews} onClick={handleSeedReviews}>Seed Default Reviews</Button>
//           )}
//           <Button type="primary" icon={<PlusOutlined />} onClick={openAddReview}>Add Review</Button>
//         </Space>
//       </div>

//       {reviewsLoading ? <div>Loading reviews…</div> : (
//         <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))', gap: 16, marginBottom: 32 }}>
//           {reviews.map((r, idx) => (
//             <Card
//               key={r.id}
//               style={{ borderLeft: '3px solid #c8f04a', background: '#fff' }}
//               title={
//                 <Space>
//                   <span style={{
//                     fontFamily: 'Space Mono, monospace',
//                     fontSize: 11, color: '#888',
//                     background: '#f5f5f5', padding: '1px 6px', borderRadius: 3,
//                   }}>
//                     #{r.order ?? idx + 1}
//                   </span>
//                   <Text strong style={{ color: '#000' }}>{r.name}</Text>
//                 </Space>
//               }
//               extra={
//                 <Space>
//                   <Button size="small" icon={<EditOutlined />} onClick={() => openEditReview(r)} />
//                   <Popconfirm title="Delete this review?" onConfirm={() => handleDeleteReview(r.id)}>
//                     <Button size="small" danger icon={<DeleteOutlined />} />
//                   </Popconfirm>
//                 </Space>
//               }
//               size="small"
//             >
//               <Space direction="vertical" size={4} style={{ width: '100%' }}>
//                 <Text style={{ color: '#888', fontSize: 12 }}><b>Role:</b> {r.role}</Text>
//                 <Space size={6}>
//                   <Tag color="lime" style={{ color: '#000', fontSize: 10 }}>{r.tag}</Tag>
//                   <Text style={{ color: '#bbb', fontSize: 11 }}>{r.year}</Text>
//                 </Space>
//                 <Text style={{ color: '#555', fontSize: 11, fontStyle: 'italic', lineHeight: 1.6 }}>
//                   "{r.text}"
//                 </Text>
//               </Space>
//             </Card>
//           ))}
//         </div>
//       )}

//       {/* ── Add / Edit Cert Modal ─────────────────────────────────────────── */}
//       <Modal
//         title={editing ? 'Edit Certificate' : 'Add Certificate'}
//         open={modalOpen}
//         onOk={handleSave}
//         onCancel={() => setModalOpen(false)}
//         okText="Save"
//         width={580}
//       >
//         <Form form={form} layout="vertical" style={{ marginTop: 16 }}>

//           <Form.Item name="title" label="Certificate Title" rules={[{ required: true }]}>
//             <Input placeholder="Beginner Python" />
//           </Form.Item>

//           <Space style={{ width: '100%' }} size={12}>
//             <Form.Item name="issuer" label="Issuer" rules={[{ required: true }]} style={{ flex: 1 }}>
//               <Input placeholder="SoloLearn" />
//             </Form.Item>
//             <Form.Item name="year" label="Year" rules={[{ required: true }]} style={{ width: 100 }}>
//               <Input placeholder="2024" />
//             </Form.Item>
//             <Form.Item name="order" label="Order" style={{ width: 80 }}>
//               <InputNumber min={1} style={{ width: '100%' }} />
//             </Form.Item>
//           </Space>

//           <Form.Item label="Accent Color" required>
//             <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 8 }}>
//               <div style={{
//                 width: 28, height: 28, borderRadius: 4,
//                 background: selectedColor,
//                 border: '1px solid #d9d9d9', flexShrink: 0,
//               }} />
//               <span style={{ fontFamily: 'Space Mono, monospace', fontSize: 12, color: '#555' }}>
//                 {selectedColor.toUpperCase()}
//               </span>
//             </div>
//             <ColorSelect
//               value={selectedColor}
//               onChange={setSelectedColor}
//               themeColors={themeColors}
//               loading={themeLoading}
//               storageKey="admin_custom_colors_certificates"
//             />
//           </Form.Item>

//           <Form.Item name="src" label="Certificate Image URL / Path" rules={[{ required: true }]}>
//             <Input placeholder="./Beg_python-1.png  or  https://..." />
//           </Form.Item>

//           <Form.Item name="desc" label="Description" rules={[{ required: true }]}>
//             <TextArea rows={3} placeholder="What this certificate covers…" />
//           </Form.Item>

//           <Form.Item label="Tags">
//             <Space style={{ marginBottom: 8 }}>
//               <Input
//                 placeholder="Add tag…"
//                 value={tagInput}
//                 onChange={e => setTagInput(e.target.value)}
//                 onPressEnter={addTag}
//                 style={{ width: 200 }}
//               />
//               <Button onClick={addTag} icon={<PlusOutlined />}>Add</Button>
//             </Space>
//             <div>
//               {tags.map((t, i) => (
//                 <Tag key={i} closable onClose={() => setTags(tags.filter((_, idx) => idx !== i))} style={{ marginBottom: 4 }}>
//                   {t}
//                 </Tag>
//               ))}
//             </div>
//           </Form.Item>

//         </Form>
//       </Modal>

//       {/* ── Add / Edit Review Modal ───────────────────────────────────────── */}
//       <Modal
//         title={editingReview ? 'Edit Review' : 'Add Review'}
//         open={reviewModal}
//         onOk={handleSaveReview}
//         onCancel={() => setReviewModal(false)}
//         okText="Save"
//         width={560}
//       >
//         <Form form={reviewForm} layout="vertical" style={{ marginTop: 16 }}>

//           <Space style={{ width: '100%' }} size={12}>
//             <Form.Item name="name" label="Name" rules={[{ required: true }]} style={{ flex: 1 }}>
//               <Input placeholder="Arjun Mehta" />
//             </Form.Item>
//             <Form.Item name="order" label="Order" style={{ width: 80 }}>
//               <InputNumber min={1} style={{ width: '100%' }} />
//             </Form.Item>
//           </Space>

//           <Form.Item name="role" label="Role / Company" rules={[{ required: true }]}>
//             <Input placeholder="Founder, Orbit Labs" />
//           </Form.Item>

//           <Form.Item name="text" label="Review Text" rules={[{ required: true }]}>
//             <TextArea rows={4} placeholder="What they said about working with you…" showCount maxLength={320} />
//           </Form.Item>

//           <Space style={{ width: '100%' }} size={12}>
//             <Form.Item name="tag" label="Category Tag" rules={[{ required: true }]} style={{ flex: 1 }}>
//               <Select
//                 placeholder="Select or type a tag"
//                 options={TAG_OPTIONS.map(t => ({ label: t, value: t }))}
//                 showSearch
//                 allowClear
//               />
//             </Form.Item>
//             <Form.Item name="year" label="Year" rules={[{ required: true }]} style={{ width: 100 }}>
//               <Input placeholder="2024" />
//             </Form.Item>
//           </Space>

//         </Form>
//       </Modal>
//     </>
//   );
// }
import React, { useEffect, useState } from 'react';
import {
  Button, Modal, Form, Input, InputNumber,
  Space, Tag, Popconfirm, message, Typography, Card, Alert, Divider, Select,
} from 'antd';
import {
  PlusOutlined, EditOutlined, DeleteOutlined,
  PictureOutlined, StarOutlined,
} from '@ant-design/icons';
import { REST_BASE, API_KEY } from '../firebase/config';
import { useThemeColors } from '../hooks/Usethemecolors';
import ColorSelect from '../components/ColorSelect';

const { Title, Text } = Typography;
const { TextArea } = Input;

// ── REST helpers ──────────────────────────────────────────────────────────────

function toValue(v) {
  if (v === null || v === undefined) return { nullValue: null };
  if (typeof v === 'boolean')        return { booleanValue: v };
  if (typeof v === 'number')         return Number.isInteger(v) ? { integerValue: String(v) } : { doubleValue: v };
  if (typeof v === 'string')         return { stringValue: v };
  if (Array.isArray(v))              return { arrayValue: { values: v.map(toValue) } };
  if (typeof v === 'object')         return { mapValue: { fields: toFields(v) } };
  return { stringValue: String(v) };
}
function toFields(obj) {
  const f = {};
  for (const [k, v] of Object.entries(obj)) f[k] = toValue(v);
  return f;
}
function fromValue(v) {
  if (!v) return null;
  if ('stringValue'  in v) return v.stringValue;
  if ('integerValue' in v) return Number(v.integerValue);
  if ('doubleValue'  in v) return Number(v.doubleValue);
  if ('booleanValue' in v) return v.booleanValue;
  if ('nullValue'    in v) return null;
  if ('arrayValue'   in v) return (v.arrayValue.values || []).map(fromValue);
  if ('mapValue'     in v) {
    const o = {};
    for (const [k, val] of Object.entries(v.mapValue.fields || {})) o[k] = fromValue(val);
    return o;
  }
  return null;
}
function fromFields(fields) {
  const o = {};
  for (const [k, v] of Object.entries(fields)) o[k] = fromValue(v);
  return o;
}

async function restGet(col) {
  const res = await fetch(`${REST_BASE}/${col}?key=${API_KEY}&orderBy=order`);
  if (res.status === 404) return [];
  if (!res.ok) throw new Error(`GET ${col} failed: ${res.status}`);
  const json = await res.json();
  if (!json.documents) return [];
  return json.documents.map(d => ({ id: d.name.split('/').pop(), ...fromFields(d.fields || {}) }));
}
async function restSet(col, id, data) {
  const res = await fetch(`${REST_BASE}/${col}/${id}?key=${API_KEY}`, {
    method: 'PATCH', headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ fields: toFields(data) }),
  });
  if (!res.ok) { const e = await res.json().catch(() => {}); throw new Error(e?.error?.message || `Save failed: ${res.status}`); }
}
async function restPost(col, data) {
  const res = await fetch(`${REST_BASE}/${col}?key=${API_KEY}`, {
    method: 'POST', headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ fields: toFields(data) }),
  });
  if (!res.ok) { const e = await res.json().catch(() => {}); throw new Error(e?.error?.message || `Add failed: ${res.status}`); }
  return (await res.json()).name.split('/').pop();
}
async function restDelete(col, id) {
  const res = await fetch(`${REST_BASE}/${col}/${id}?key=${API_KEY}`, { method: 'DELETE' });
  if (!res.ok && res.status !== 404) throw new Error(`Delete failed: ${res.status}`);
}

// ── Seed data ─────────────────────────────────────────────────────────────────

const SEED_CERTS = [
  { title:'Beginner Python',         issuer:'SoloLearn', year:'2023', color:'#c8f04a', src:'./Beg_python-1.png',         tags:['Python','Programming','Basics'],            desc:'Covers Python fundamentals including variables, loops, functions, and problem-solving concepts.', order:1 },
  { title:'Data Structure in Python',issuer:'SoloLearn', year:'2023', color:'#00e5ff', src:'./data_structure-1.png',      tags:['Python','Data Structures','Algorithms'],    desc:'Demonstrates understanding of Python data structures such as lists, stacks, queues, dictionaries, and algorithms.', order:2 },
  { title:'Data Science for Python', issuer:'SoloLearn', year:'2023', color:'#a78bfa', src:'./Dtsc-1.png',                tags:['Python','Data Science','Analytics'],        desc:'Focuses on Python for data analysis, visualization, and introductory data science concepts.', order:3 },
  { title:'Intermediate Python',     issuer:'SoloLearn', year:'2023', color:'#c8f04a', src:'./intermediate_python-1.png', tags:['Python','Advanced Concepts','Programming'], desc:'Covers intermediate Python concepts including OOP, exception handling, modules, and file management.', order:4 },
  { title:'JavaScript',              issuer:'SoloLearn', year:'2023', color:'#00e5ff', src:'./js-1.png',                  tags:['JavaScript','Frontend','Web Development'],  desc:'Builds JavaScript fundamentals including DOM manipulation, ES6 features, functions, and async concepts.', order:5 },
  { title:'Prompt Engineering',      issuer:'SoloLearn', year:'2026', color:'#ff6b6b', src:'./PE-1.png',                  tags:['AI','Prompt Engineering','LLMs'],            desc:'Covers prompt optimization, AI communication, and effective prompting techniques for large language models.', order:6 },
];

const SEED_REVIEWS = [
  {
    name: 'Bala Vishnu R',
    role: 'CEO,Techno Tackle',
    text: 'This is one of the coolest ways to send resumes. I really like the concept and how smoothly it works. It offers a creative and modern approach to job applications, making the process faster and more efficient. The idea stands out from traditional resume submissions and shows strong innovation.',
    tag: 'Resume Sender',
    year: '2026',
    order: 1,
  },
  {
    name: 'Vignesh Waran',
    role: 'Junior HR, Evolv Clothing Company Pvt Ltd',
    text: 'A clean and professional portfolio that showcases projects effectively and makes it easy to understand the candidate\'s skills and experience.',
    tag: 'Portfolio Website',
    year: '2026',
    order: 2,
  },
];

// Default tags seeded into Firestore on first load if collection is empty
const DEFAULT_TAG_OPTIONS = [
  'UI/UX','Frontend Dev','Full Stack','Product Design','React / GSAP',
  'Backend','Mobile','DevOps','Branding','Consulting',
  'Resume Sender','Portfolio Website',
];

// ── Main component ────────────────────────────────────────────────────────────

export default function CertificatesPage() {
  const [data,          setData]          = useState([]);
  const [loading,       setLoading]       = useState(false);
  const [modalOpen,     setModalOpen]     = useState(false);
  const [editing,       setEditing]       = useState(null);
  const [seeding,       setSeeding]       = useState(false);
  const [tags,          setTags]          = useState([]);
  const [tagInput,      setTagInput]      = useState('');

  // ── Reviews state ─────────────────────────────────────────────────────────
  const [reviews,        setReviews]        = useState([]);
  const [reviewsLoading, setReviewsLoading] = useState(false);
  const [reviewModal,    setReviewModal]    = useState(false);
  const [editingReview,  setEditingReview]  = useState(null);
  const [seedingReviews, setSeedingReviews] = useState(false);

  // ── Dynamic review tags state ──────────────────────────────────────────────
  const [reviewTagOptions,    setReviewTagOptions]    = useState([]);
  const [reviewTagsLoading,   setReviewTagsLoading]   = useState(false);
  const [newTagInput,         setNewTagInput]         = useState('');
  const [addingTag,           setAddingTag]           = useState(false);

  // ── Section settings (outro images) ───────────────────────────────────────
  const [settingsSaving, setSettingsSaving] = useState(false);
  const [settingsLoaded, setSettingsLoaded] = useState(false);

  // ── Controlled color state — kept outside form ────────────────────────────
  const [selectedColor, setSelectedColor] = useState('#c8f04a');

  const [form]         = Form.useForm();
  const [settingsForm] = Form.useForm();
  const [reviewForm]   = Form.useForm();

  const { themeColors, loading: themeLoading, error: themeError } = useThemeColors();

  // ── Load certificates ─────────────────────────────────────────────────────
  const load = async () => {
    setLoading(true);
    try { setData(await restGet('certificates')); }
    catch (e) { message.error('Load failed: ' + e.message); }
    finally { setLoading(false); }
  };

  // ── Load reviews ──────────────────────────────────────────────────────────
  const loadReviews = async () => {
    setReviewsLoading(true);
    try { setReviews(await restGet('reviews')); }
    catch (e) { message.error('Reviews load failed: ' + e.message); }
    finally { setReviewsLoading(false); }
  };

  // ── Load review tags from Firestore ───────────────────────────────────────
  // Stored as individual documents in "reviewTags" collection
  // Each doc: { label: string, order: number }
  const loadReviewTags = async () => {
    setReviewTagsLoading(true);
    try {
      const res = await fetch(`${REST_BASE}/reviewTags?key=${API_KEY}`);
      if (res.status === 404 || !res.ok) {
        // Collection doesn't exist yet — seed defaults
        await seedDefaultTags();
        return;
      }
      const json = await res.json();
      if (!json.documents || json.documents.length === 0) {
        await seedDefaultTags();
        return;
      }
      const loaded = json.documents.map(d => ({
        id: d.name.split('/').pop(),
        ...fromFields(d.fields || {}),
      }));
      // Sort by order field, fallback to label alpha
      loaded.sort((a, b) => (a.order ?? 999) - (b.order ?? 999) || a.label.localeCompare(b.label));
      setReviewTagOptions(loaded);
    } catch (e) {
      message.error('Tags load failed: ' + e.message);
    } finally {
      setReviewTagsLoading(false);
    }
  };

  // ── Seed default tags into Firestore ──────────────────────────────────────
  const seedDefaultTags = async () => {
    try {
      const seeded = [];
      for (let i = 0; i < DEFAULT_TAG_OPTIONS.length; i++) {
        const id = await restPost('reviewTags', { label: DEFAULT_TAG_OPTIONS[i], order: i + 1 });
        seeded.push({ id, label: DEFAULT_TAG_OPTIONS[i], order: i + 1 });
      }
      setReviewTagOptions(seeded);
    } catch (e) {
      // Silently fall back — tags still usable as local state
      setReviewTagOptions(DEFAULT_TAG_OPTIONS.map((label, i) => ({ id: null, label, order: i + 1 })));
    }
  };

  // ── Add a new review tag to Firestore ─────────────────────────────────────
  const handleAddNewTag = async () => {
    const label = newTagInput.trim();
    if (!label) return;
    if (reviewTagOptions.some(t => t.label.toLowerCase() === label.toLowerCase())) {
      message.warning('Tag already exists');
      return;
    }
    setAddingTag(true);
    try {
      const order = reviewTagOptions.length + 1;
      const id = await restPost('reviewTags', { label, order });
      const newTag = { id, label, order };
      setReviewTagOptions(prev => [...prev, newTag]);
      // Auto-select it in the form
      reviewForm.setFieldsValue({ tag: label });
      setNewTagInput('');
      message.success(`Tag "${label}" created!`);
    } catch (e) {
      message.error('Failed to create tag: ' + e.message);
    } finally {
      setAddingTag(false);
    }
  };

  // ── Delete a review tag from Firestore ────────────────────────────────────
  const handleDeleteTag = async (tagItem) => {
    if (!tagItem.id) return;
    try {
      await restDelete('reviewTags', tagItem.id);
      setReviewTagOptions(prev => prev.filter(t => t.id !== tagItem.id));
      message.success(`Tag "${tagItem.label}" deleted`);
    } catch (e) {
      message.error('Failed to delete tag: ' + e.message);
    }
  };

  // ── Load section settings ─────────────────────────────────────────────────
  const loadSettings = async () => {
    try {
      const res = await fetch(`${REST_BASE}/settings/certificates?key=${API_KEY}`);
      if (res.ok) {
        const json = await res.json();
        const s = fromFields(json.fields || {});
        settingsForm.setFieldsValue({
          maskImage:   s.maskImage   || './mask.png',
          revealImage: s.revealImage || './desktop.png',
        });
      } else {
        settingsForm.setFieldsValue({ maskImage: './mask.png', revealImage: './desktop.png' });
      }
    } catch {
      settingsForm.setFieldsValue({ maskImage: './mask.png', revealImage: './desktop.png' });
    } finally {
      setSettingsLoaded(true);
    }
  };

  // ── Save section settings ─────────────────────────────────────────────────
  const saveSettings = async () => {
    try {
      setSettingsSaving(true);
      const vals = await settingsForm.validateFields();
      await restSet('settings', 'certificates', vals);
      message.success('Outro images saved!');
    } catch (e) {
      if (!e?.errorFields) message.error('Save failed: ' + (e.message || ''));
    } finally {
      setSettingsSaving(false);
    }
  };

  useEffect(() => {
    load();
    loadReviews();
    loadSettings();
    loadReviewTags();
  }, []);

  // ── Open cert modal ───────────────────────────────────────────────────────
  const openAdd = () => {
    setEditing(null);
    form.resetFields();
    const defaultColor = themeColors.find(c => c.varName === '--acid')?.hex || '#c8f04a';
    setSelectedColor(defaultColor);
    form.setFieldsValue({ year: String(new Date().getFullYear()), order: data.length + 1 });
    setTags([]);
    setTagInput('');
    setModalOpen(true);
  };

  const openEdit = (record) => {
    setEditing(record);
    setSelectedColor(record.color || '#c8f04a');
    form.setFieldsValue({
      title:  record.title,
      issuer: record.issuer,
      year:   record.year,
      src:    record.src,
      desc:   record.desc,
      order:  record.order,
    });
    setTags(record.tags || []);
    setTagInput('');
    setModalOpen(true);
  };

  // ── Save certificate ──────────────────────────────────────────────────────
  const handleSave = async () => {
    try {
      const vals = await form.validateFields();
      const payload = { ...vals, color: selectedColor, tags };
      if (editing) {
        await restSet('certificates', editing.id, payload);
        message.success('Certificate updated!');
      } else {
        await restPost('certificates', payload);
        message.success('Certificate added!');
      }
      setModalOpen(false);
      load();
    } catch (e) {
      if (e?.errorFields) return;
      message.error('Save failed: ' + (e.message || ''));
    }
  };

  // ── Delete certificate ────────────────────────────────────────────────────
  const handleDelete = async (id) => {
    try { await restDelete('certificates', id); message.success('Deleted'); load(); }
    catch (e) { message.error('Delete failed: ' + e.message); }
  };

  // ── Seed certificates ─────────────────────────────────────────────────────
  const handleSeed = async () => {
    setSeeding(true);
    try {
      const acid   = themeColors.find(c => c.varName === '--acid')?.hex   || '#c8f04a';
      const cyan   = themeColors.find(c => c.varName === '--cyan')?.hex   || '#00e5ff';
      const purple = themeColors.find(c => c.varName === '--purple')?.hex || '#a78bfa';
      const red    = themeColors.find(c => c.varName === '--red')?.hex    || '#ff6b6b';
      const themed = SEED_CERTS.map((cert, i) => ({
        ...cert,
        color: [acid, cyan, purple, acid, cyan, red][i] || cert.color,
      }));
      for (const cert of themed) await restPost('certificates', cert);
      message.success('Seeded all certificates!');
      load();
    } catch (e) {
      message.error('Seed failed: ' + e.message);
    } finally {
      setSeeding(false);
    }
  };

  // ── Open review modal ─────────────────────────────────────────────────────
  const openAddReview = () => {
    setEditingReview(null);
    reviewForm.resetFields();
    reviewForm.setFieldsValue({ year: String(new Date().getFullYear()), order: reviews.length + 1 });
    setNewTagInput('');
    setReviewModal(true);
  };

  const openEditReview = (r) => {
    setEditingReview(r);
    reviewForm.setFieldsValue({
      name:  r.name,
      role:  r.role,
      text:  r.text,
      tag:   r.tag,
      year:  r.year,
      order: r.order,
    });
    setNewTagInput('');
    setReviewModal(true);
  };

  // ── Save review ───────────────────────────────────────────────────────────
  const handleSaveReview = async () => {
    try {
      const vals = await reviewForm.validateFields();
      if (editingReview) {
        await restSet('reviews', editingReview.id, vals);
        message.success('Review updated!');
      } else {
        await restPost('reviews', vals);
        message.success('Review added!');
      }
      setReviewModal(false);
      loadReviews();
    } catch (e) {
      if (e?.errorFields) return;
      message.error('Save failed: ' + (e.message || ''));
    }
  };

  // ── Delete review ─────────────────────────────────────────────────────────
  const handleDeleteReview = async (id) => {
    try { await restDelete('reviews', id); message.success('Deleted'); loadReviews(); }
    catch (e) { message.error('Delete failed: ' + e.message); }
  };

  // ── Seed reviews ──────────────────────────────────────────────────────────
  const handleSeedReviews = async () => {
    setSeedingReviews(true);
    try {
      for (const r of SEED_REVIEWS) await restPost('reviews', r);
      message.success('Seeded all reviews!');
      loadReviews();
    } catch (e) {
      message.error('Seed failed: ' + e.message);
    } finally {
      setSeedingReviews(false);
    }
  };

  // ── Tags (cert) ───────────────────────────────────────────────────────────
  const addTag = () => {
    const t = tagInput.trim();
    if (t && !tags.includes(t)) setTags([...tags, t]);
    setTagInput('');
  };

  // ── Build Select options for review tags ──────────────────────────────────
  const reviewTagSelectOptions = reviewTagOptions.map(t => ({
    label: t.label,
    value: t.label,
  }));

  return (
    <>
      {/* ── Page header ──────────────────────────────────────────────────── */}
      <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Title level={4} style={{ margin: 0 }}>Certificates</Title>
        <Space>
          {data.length === 0 && (
            <Button loading={seeding} onClick={handleSeed}>Seed Default Certs</Button>
          )}
          <Button type="primary" icon={<PlusOutlined />} onClick={openAdd}>Add Certificate</Button>
        </Space>
      </div>

      {themeError && (
        <Alert message={themeError} type="warning" showIcon closable style={{ marginBottom: 12 }} />
      )}

      {/* ── Section Settings Card ─────────────────────────────────────────── */}
      <Card
        title={
          <Space>
            <PictureOutlined style={{ color: '#a78bfa' }} />
            <Text strong>Outro Section Images</Text>
          </Space>
        }
        style={{ marginBottom: 20, borderLeft: '3px solid #a78bfa' }}
        extra={
          <Button type="primary" loading={settingsSaving} onClick={saveSettings} disabled={!settingsLoaded}>
            Save Images
          </Button>
        }
        size="small"
      >
        <Alert
          message={
            <span>
              These two images power the interactive <b>"hover to reveal"</b> outro shown after all certificates.
              Use a relative path (<code>./mask.png</code>) for public folder images, or a full <code>https://</code> URL.
            </span>
          }
          type="info" showIcon style={{ marginBottom: 14 }}
        />
        <Form form={settingsForm} layout="vertical" initialValues={{ maskImage: './mask.png', revealImage: './desktop.png' }}>
          <Space style={{ width: '100%' }} size={12} direction="vertical">
            <Form.Item
              name="maskImage"
              label="Base Image (always visible, desaturated background)"
              rules={[{ required: true, message: 'Base image URL is required' }]}
              style={{ marginBottom: 0 }}
              extra="Shown at all times as the greyed-out background portrait."
            >
              <Input placeholder="./mask.png  or  https://cdn.example.com/mask.jpg" />
            </Form.Item>
            <Form.Item
              name="revealImage"
              label="Reveal Image (shown inside the hover silhouette)"
              rules={[{ required: true, message: 'Reveal image URL is required' }]}
              style={{ marginBottom: 0 }}
              extra="Revealed in full colour only where the user hovers over the silhouette."
            >
              <Input placeholder="./desktop.png  or  https://cdn.example.com/reveal.jpg" />
            </Form.Item>
          </Space>
        </Form>
      </Card>

      {/* ── Cert image tip ───────────────────────────────────────────────── */}
      <Alert
        message='Tip: "src" is the certificate image. Use a relative path (./cert.png) for public folder images, or a full HTTPS URL.'
        type="info" showIcon style={{ marginBottom: 16 }}
      />

      {/* ── Certificate grid ─────────────────────────────────────────────── */}
      {loading ? <div>Loading…</div> : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))', gap: 16 }}>
          {data.map(cert => (
            <Card
              key={cert.id}
              style={{ borderLeft: `3px solid ${cert.color}`, background: '#fff' }}
              title={
                <Space>
                  <span style={{ width: 10, height: 10, borderRadius: '50%', background: cert.color, display: 'inline-block' }} />
                  <Text strong style={{ color: '#000' }}>{cert.title}</Text>
                </Space>
              }
              extra={
                <Space>
                  <Button size="small" icon={<EditOutlined />} onClick={() => openEdit(cert)} />
                  <Popconfirm title="Delete this certificate?" onConfirm={() => handleDelete(cert.id)}>
                    <Button size="small" danger icon={<DeleteOutlined />} />
                  </Popconfirm>
                </Space>
              }
              size="small"
            >
              <Space direction="vertical" size={4} style={{ width: '100%' }}>
                <Text style={{ color: '#888', fontSize: 12 }}><b>Issuer:</b> {cert.issuer}</Text>
                <Text style={{ color: '#888', fontSize: 12 }}><b>Year:</b> {cert.year}</Text>
                <Text style={{ color: '#888', fontSize: 12 }}><b>Order:</b> {cert.order}</Text>
                <Text style={{ color: '#666', fontSize: 11 }}>{cert.desc}</Text>
                <div style={{ marginTop: 4 }}>
                  {(cert.tags || []).map((t, i) => (
                    <Tag key={i} color={cert.color} style={{ color: '#000', fontSize: 10, marginBottom: 4 }}>{t}</Tag>
                  ))}
                </div>
              </Space>
            </Card>
          ))}
        </div>
      )}

      {/* ════════════════════════════════════════════════════════════════════ */}
      {/*  REVIEWS SECTION                                                    */}
      {/* ════════════════════════════════════════════════════════════════════ */}
      <Divider style={{ margin: '32px 0 24px' }} />

      <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Space align="center">
          <StarOutlined style={{ color: '#c8f04a', fontSize: 18 }} />
          <Title level={4} style={{ margin: 0 }}>Reviews</Title>
          <Text type="secondary" style={{ fontSize: 12 }}>shown in the outro card-stack after certificates</Text>
        </Space>
        <Space>
          {reviews.length === 0 && (
            <Button loading={seedingReviews} onClick={handleSeedReviews}>Seed Default Reviews</Button>
          )}
          <Button type="primary" icon={<PlusOutlined />} onClick={openAddReview}>Add Review</Button>
        </Space>
      </div>

      {reviewsLoading ? <div>Loading reviews…</div> : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))', gap: 16, marginBottom: 32 }}>
          {reviews.map((r, idx) => (
            <Card
              key={r.id}
              style={{ borderLeft: '3px solid #c8f04a', background: '#fff' }}
              title={
                <Space>
                  <span style={{
                    fontFamily: 'Space Mono, monospace',
                    fontSize: 11, color: '#888',
                    background: '#f5f5f5', padding: '1px 6px', borderRadius: 3,
                  }}>
                    #{r.order ?? idx + 1}
                  </span>
                  <Text strong style={{ color: '#000' }}>{r.name}</Text>
                </Space>
              }
              extra={
                <Space>
                  <Button size="small" icon={<EditOutlined />} onClick={() => openEditReview(r)} />
                  <Popconfirm title="Delete this review?" onConfirm={() => handleDeleteReview(r.id)}>
                    <Button size="small" danger icon={<DeleteOutlined />} />
                  </Popconfirm>
                </Space>
              }
              size="small"
            >
              <Space direction="vertical" size={4} style={{ width: '100%' }}>
                <Text style={{ color: '#888', fontSize: 12 }}><b>Role:</b> {r.role}</Text>
                <Space size={6}>
                  <Tag color="lime" style={{ color: '#000', fontSize: 10 }}>{r.tag}</Tag>
                  <Text style={{ color: '#bbb', fontSize: 11 }}>{r.year}</Text>
                </Space>
                <Text style={{ color: '#555', fontSize: 11, fontStyle: 'italic', lineHeight: 1.6 }}>
                  "{r.text}"
                </Text>
              </Space>
            </Card>
          ))}
        </div>
      )}

      {/* ── Add / Edit Cert Modal ─────────────────────────────────────────── */}
      <Modal
        title={editing ? 'Edit Certificate' : 'Add Certificate'}
        open={modalOpen}
        onOk={handleSave}
        onCancel={() => setModalOpen(false)}
        okText="Save"
        width={580}
      >
        <Form form={form} layout="vertical" style={{ marginTop: 16 }}>

          <Form.Item name="title" label="Certificate Title" rules={[{ required: true }]}>
            <Input placeholder="Beginner Python" />
          </Form.Item>

          <Space style={{ width: '100%' }} size={12}>
            <Form.Item name="issuer" label="Issuer" rules={[{ required: true }]} style={{ flex: 1 }}>
              <Input placeholder="SoloLearn" />
            </Form.Item>
            <Form.Item name="year" label="Year" rules={[{ required: true }]} style={{ width: 100 }}>
              <Input placeholder="2024" />
            </Form.Item>
            <Form.Item name="order" label="Order" style={{ width: 80 }}>
              <InputNumber min={1} style={{ width: '100%' }} />
            </Form.Item>
          </Space>

          <Form.Item label="Accent Color" required>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 8 }}>
              <div style={{
                width: 28, height: 28, borderRadius: 4,
                background: selectedColor,
                border: '1px solid #d9d9d9', flexShrink: 0,
              }} />
              <span style={{ fontFamily: 'Space Mono, monospace', fontSize: 12, color: '#555' }}>
                {selectedColor.toUpperCase()}
              </span>
            </div>
            <ColorSelect
              value={selectedColor}
              onChange={setSelectedColor}
              themeColors={themeColors}
              loading={themeLoading}
              storageKey="admin_custom_colors_certificates"
            />
          </Form.Item>

          <Form.Item name="src" label="Certificate Image URL / Path" rules={[{ required: true }]}>
            <Input placeholder="./Beg_python-1.png  or  https://..." />
          </Form.Item>

          <Form.Item name="desc" label="Description" rules={[{ required: true }]}>
            <TextArea rows={3} placeholder="What this certificate covers…" />
          </Form.Item>

          <Form.Item label="Tags">
            <Space style={{ marginBottom: 8 }}>
              <Input
                placeholder="Add tag…"
                value={tagInput}
                onChange={e => setTagInput(e.target.value)}
                onPressEnter={addTag}
                style={{ width: 200 }}
              />
              <Button onClick={addTag} icon={<PlusOutlined />}>Add</Button>
            </Space>
            <div>
              {tags.map((t, i) => (
                <Tag key={i} closable onClose={() => setTags(tags.filter((_, idx) => idx !== i))} style={{ marginBottom: 4 }}>
                  {t}
                </Tag>
              ))}
            </div>
          </Form.Item>

        </Form>
      </Modal>

      {/* ── Add / Edit Review Modal ───────────────────────────────────────── */}
      <Modal
        title={editingReview ? 'Edit Review' : 'Add Review'}
        open={reviewModal}
        onOk={handleSaveReview}
        onCancel={() => { setReviewModal(false); setNewTagInput(''); }}
        okText="Save"
        width={560}
      >
        <Form form={reviewForm} layout="vertical" style={{ marginTop: 16 }}>

          <Space style={{ width: '100%' }} size={12}>
            <Form.Item name="name" label="Name" rules={[{ required: true }]} style={{ flex: 1 }}>
              <Input placeholder="Arjun Mehta" />
            </Form.Item>
            <Form.Item name="order" label="Order" style={{ width: 80 }}>
              <InputNumber min={1} style={{ width: '100%' }} />
            </Form.Item>
          </Space>

          <Form.Item name="role" label="Role / Company" rules={[{ required: true }]}>
            <Input placeholder="Founder, Orbit Labs" />
          </Form.Item>

          <Form.Item name="text" label="Review Text" rules={[{ required: true }]}>
            <TextArea rows={4} placeholder="What they said about working with you…" showCount maxLength={320} />
          </Form.Item>

          <Space style={{ width: '100%' }} size={12}>
            {/* ── Dynamic category tag select ── */}
            <Form.Item
              name="tag"
              label="Category Tag"
              rules={[{ required: true, message: 'Please select or create a tag' }]}
              style={{ flex: 1 }}
            >
              <Select
                placeholder={reviewTagsLoading ? 'Loading tags…' : 'Select a tag'}
                loading={reviewTagsLoading}
                options={reviewTagSelectOptions}
                showSearch
                allowClear
                filterOption={(input, option) =>
                  option.label.toLowerCase().includes(input.toLowerCase())
                }
                dropdownRender={menu => (
                  <>
                    {menu}
                    <div style={{ padding: '8px 8px 4px', borderTop: '1px solid #f0f0f0' }}>
                      <Space.Compact style={{ width: '100%' }}>
                        <Input
                          placeholder="New tag name…"
                          value={newTagInput}
                          onChange={e => setNewTagInput(e.target.value)}
                          onPressEnter={handleAddNewTag}
                          size="small"
                          style={{ flex: 1 }}
                        />
                        <Button
                          type="primary"
                          size="small"
                          icon={<PlusOutlined />}
                          loading={addingTag}
                          onClick={handleAddNewTag}
                          disabled={!newTagInput.trim()}
                        >
                          Create
                        </Button>
                      </Space.Compact>
                      {/* Manage existing tags inline */}
                      {reviewTagOptions.length > 0 && (
                        <div style={{ marginTop: 8 }}>
                          <Text type="secondary" style={{ fontSize: 11, display: 'block', marginBottom: 4 }}>
                            Manage tags (click × to delete from backend):
                          </Text>
                          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
                            {reviewTagOptions.map(t => (
                              <Tag
                                key={t.id || t.label}
                                closable
                                onClose={e => { e.preventDefault(); handleDeleteTag(t); }}
                                style={{ fontSize: 11, cursor: 'default' }}
                              >
                                {t.label}
                              </Tag>
                            ))}
                          </div>
                        </div>
                      )}
                    </div>
                  </>
                )}
              />
            </Form.Item>

            <Form.Item name="year" label="Year" rules={[{ required: true }]} style={{ width: 100 }}>
              <Input placeholder="2024" />
            </Form.Item>
          </Space>

        </Form>
      </Modal>
    </>
  );
}